import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Avatar, Divider } from '@material-ui/core'
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import SpecificComponent from '../../commons/SpecificComponent';
import Masks from '../../providers/Masks';
import avatar from '../../Pics/avatar.jpg'





export default class Monitorizare extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            editReady: false,
            dataAzi: this.u.defaultData(),
            utilizatori: []
        }
    }

    componentDidMount() {
        this.getUsers()

    }

    u = new Utils();
    ws = new Ws()
    m = new Masks()

    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }


    getUsers = async () => {


        let getSocietate = await this.ws.customSelect('select * from setari', {
            p1: 'soc_code'
        })


        if (getSocietate.Succes) {

            let _monitorAngajati = this.ws.customSelect(`select * from monitorizare_log_folosire where cand_received between DATEADD(minute, -15, getdate()) and getdate() order by cand_received desc`, {
                p1: this.state.dataAzi
            })

            let _monitorAllDay = this.ws.customSelect('select * from monitorizare_log_folosire where Cast(cand_received as date) = @p1 order by cand_received desc', {
                p1: this.state.dataAzi
            })

            

            let _users = this.ws.customSelect(`select
                a.id ,u.inactiv as inactiv_user, dep.id as id_departament, u.id as id_user,
                l.parola, l.parolac, l.email as email_logator, l.id_user_bazadate_proprie,
                ad.sef_departament,a.cnp,a.adresa,a.telefon,
                a.nume, a.poza, a.cost_minut, a.functie,a.oras, a.salariu, a.doc_fisa_postului,a.cv, u.email, u.firma,u.firma_externa, u.is_admin, dep.nume as nume_departament  from  useri u
                left join angajati a on u.id = a.id_user 
                left join angajati_departamente ad on ad.id_angajat = a.id
                left join departamente dep on dep.id = ad.id_departament
                left join pm_logator.[dbo].useri l on u.id = l.id_user_bazadate_proprie
                where isnull(u.inactiv,0) != 1 and l.id_societate_client = @p2 and isnull(ad.inactiv,0) != 1 order by a.nume asc`, {
                p1: 1,
                p2: getSocietate.Content.length > 0 ? Number(getSocietate.Content[0].val) : 1
            })

            let [users, monitorAngajati, monitorAllDay] = await Promise.all([_users, _monitorAngajati, _monitorAllDay])

            if (monitorAngajati.Succes && users.Succes && monitorAllDay.Succes) {
                console.log('monitorAngajati :>> ', monitorAngajati);
                console.log('monitorAllDay :>> ', monitorAllDay);

                let us = [...users.Content]
                let mon = [...monitorAngajati.Content]
                let monAllDay = [...monitorAllDay.Content]


                for (let i = 0, n = us.length; i < n; i++) {

                    let filterMonitorizare = mon.filter(mo => mo.id_user === us[i].id)

                    console.log('filterMonitorizare :>> ', filterMonitorizare);


                    if (filterMonitorizare.length > 0) {
                        us[i]['last_date_received'] = filterMonitorizare[0]['cand_received']
                        us[i]['status_live'] = true
                    } else {
                        let monAllDayF = monAllDay.filter(mo => mo.id_user === us[i].id)

                        us[i]['last_date_received'] = monAllDayF.length > 0 ? monAllDayF[0]['cand_received'] : null
                        us[i]['inactive_all_day'] = this.dictionary.pontaje.inactivAzi
                        us[i]['status_live'] = false
                    }





                }


                this.setState({ utilizatori: us })


            }

        }


    }





    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth='md'
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                        <Grid container>

                                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >  {this.dictionary.pontaje.monitorizareLive}</h5>


                                            </Grid>
                                            {/* <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <div style={{ position: 'relative', textAlign: 'left' }}>
                                                    <input
                                                        style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                        id='data_'
                                                        type="date"
                                                        step='any'
                                                        className='add-project-input'
                                                        margin="normal"
                                                        name={'dataAzi'}
                                                        value={this.state.dataAzi || ''}
                                                        onChange={this.changeProgram}
                                                    />
                                                    <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.managementUtilizatori.data}</label>
                                                </div>
                                            </Grid> */}
                                        </Grid>

                                        <Divider className='pm-divider' />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                        {this.state.utilizatori.map((u, idx) => {
                                            return (
                                                <Grid key={idx} container>
                                                    <Grid style={{ paddingTop: 5 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                        <Grid container>

                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                {
                                                                    u.poza &&
                                                                    <div
                                                                        className='pm-angajati-picture'

                                                                        style={{ backgroundImage: `url('${u.poza ? (new Ws().adresaMedia + '/Angajati/' + u.poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                                                    </div>
                                                                }
                                                                {!u.poza &&

                                                                    <Avatar
                                                                        className='pm-angajati-picture'
                                                                        style={{ display: 'inline-block', textAlign: 'center', height: 24, width: 24, backgroundColor: new Utils().culoriUtilizatori(u.id), padding: 5, cursor: 'pointer' }}>
                                                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                                        <span style={{ display: 'block' }}>{this.numeAvatar(u.nume)} </span>
                                                                    </Avatar>
                                                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                }
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                                <span style={{ fontWeight: 500, fontSize: 14 }}>    {u.nume}</span><br />
                                                                <span style={{
                                                                    fontSize: 12,
                                                                    color: '#9a9a9a'
                                                                }}>{u.functie} - {u.nume_departament}</span>
                                                            </Grid>

                                                        </Grid>

                                                    </Grid>

                                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={4} sm={4} md={4} lg={4} xl={4}>


                                                        <span style={{  fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' , marginBottom:10}}>{this.dictionary.pontaje.status}</span>
                                                        <div style={{
                                                            width: 20,
                                                            height: 20,
                                                            borderRadius: '50%',
                                                            backgroundColor: u['status_live'] ? 'rgb(24	165	58)' : 'rgb(252	93	98)',
                                                            margin:'auto'
                                                        }}>

                                                        </div>

                                                    </Grid>

                                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={4} sm={4} md={4} lg={4} xl={4}>


                                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.candActiv}</span>
                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{u['last_date_received'] ? (this.u.ParseDataFromSql(u['last_date_received']) + '-' + this.u.ParseOraFromSql(u['last_date_received'])) : u['inactive_all_day']}</span>


                                                    </Grid>




                                                </Grid>
                                            )
                                        })}

                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </DialogContent>


                </Dialog>
            </div >
        );
    }
}